"use strict";
'use es6'; // Objects in these files are like ImmutableRecord defaults
// anything undefined should be overridden or else unit tests will fail
// anything null/defined can stay as such

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BizObjectivesMapDefault = exports.MerchandiseObjectDefault = exports.FeatureObjectDefault = exports.HubObjectDefault = void 0;
var HubObjectDefault = {
  merchandise: undefined,
  highlightedPaidMerch: [],
  highlightedFreeMerch: undefined,
  hubSpecificFeatures: [],
  merchPurchaseType: undefined
};
exports.HubObjectDefault = HubObjectDefault;
var FeatureObjectDefault = {
  limits: null,
  // Map of merch to limit string key
  isNew: false,
  comingSoon: false
}; // properties that should not be undefined

exports.FeatureObjectDefault = FeatureObjectDefault;
var MerchandiseObjectDefault = {
  parcels: undefined,
  billingNameKey: null,
  features: null
};
exports.MerchandiseObjectDefault = MerchandiseObjectDefault;
var BizObjectivesMapDefault = {
  features: [],
  breakoutData: null // TODO: When we have breakout pages, stuff should go here
  // Assumption being that bizObjective <-> breakout page is 1:1
  // If this assumption changes in the future, we should separate breakouts
  // into their own object and map it as necessary

};
exports.BizObjectivesMapDefault = BizObjectivesMapDefault;